import React, { ChangeEvent, useState } from 'react';
import Input from 'src/components/Input';
import FontAwesomeIcon from 'src/components/Icon';
import './password-input.scss';

interface PasswordInputProps {
  value: string;
  onChange: (value: string) => void;
  label: string;
  placeholder?: string;
  required?: boolean;
  block?: boolean;
  errors?: string;
  'data-cy'?: string;
}

const PasswordInput = ({
  value,
  onChange,
  label,
  placeholder,
  required,
  block,
  errors,
  'data-cy': dataCy,
}: PasswordInputProps) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="password-input">
      <Input
        value={value}
        onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
        label={label}
        placeholder={placeholder}
        required={required}
        mask={!showPassword}
        block={block}
        errors={errors}
        data-cy={dataCy}
      />
      <button
        type="button"
        className="password-input-toggle"
        onClick={() => setShowPassword((v) => !v)}
        aria-label={showPassword ? 'Hide password' : 'Show password'}
      >
        <FontAwesomeIcon
          glyph={showPassword ? 'eye-slash' : 'eye'}
          weight="light"
        />
      </button>
    </div>
  );
};

export default PasswordInput;
